"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, Square } from "lucide-react";
const services = ["Minimally Invasive Brain Surgery", "Comprehensive Spine Care", "Peripheral Nerve Treatment", "Multidisciplinary Consultations", "Advanced Neuro-Diagnostics"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="172901" id="footer" className="dark bg-background text-foreground pt-16 pb-8 md:pt-20 border-t border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/neurofamily_logo.png" alt="NeuroFamily Logo" className="h-7 object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm font-sans">
              NeuroFamily integrates advanced surgical techniques with a compassionate, family-centered philosophy to treat complex brain and spine conditions with precision and care.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight font-sans text-primary">Quick Navigation</h3>
            <MenuProvider menu_id="51">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight font-sans text-primary">Specialized Care</h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i} className="text-muted-foreground text-sm flex items-start gap-2 font-sans">
                  <Square className="size-2 fill-primary text-primary mt-1 shrink-0" />
                  {service}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight font-sans text-primary">Get in Touch</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-sans">
                <Phone className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>929-357-7590</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-sans">
                <Mail className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>info@seanarminoncology.com</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-sans">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span className="leading-tight">1135 GLENDALE BLVD UNIT 5, LOS ANGELES, CA, 90026</span>
              </li>
            </ul>
            
            <div className="flex items-center gap-4 mt-2">
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </div>
          </div>

        </div>

        <Separator className="my-8 bg-border/20" />

        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between text-xs text-muted-foreground font-sans">
          <p>Copyright (c) {currentYear} NeuroFamily. Treating every patient like family.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="https://app.termly.io/policy-viewer/policy.html?policyUUID=6ff250dc-8d94-4bcd-97b1-7a17f9f72b2b" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="https://app.termly.io/policy-viewer/policy.html?policyUUID=1158d34d-cd10-4550-94b0-05c997c18ef8" className="hover:text-primary transition-colors">Terms of Service</Link>
            <span className="hidden md:inline text-border/20">|</span>
            <span className="text-primary/90 font-medium">For neurological emergencies, please contact emergency services immediately.</span>
          </div>
        </div>
      </div>
    </section>;
}